<template>
    <div class="template-list">
        <slot :handleItemClick="handleItemClick">
            <!-- 기본 플레이스홀더 목록 -->
            <div class="list-header">
                <h3 class="list-title">목록</h3>
            </div>
            <div class="list-items">
                <div v-for="i in 5" :key="i" class="list-item" @click="handleItemClick({ id: i, name: `항목 ${i}` })">
                    <div class="item-content">항목 {{ i }}</div>
                </div>
            </div>
        </slot>
    </div>
</template>

<script>
export default {
    name: "TemplateList",
    methods: {
        handleItemClick(item) {
            this.$emit("item-click", item);
        },
    },
};
</script>

<style scoped>
.template-list {
    background: white;
    border-radius: 8px;
    padding: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #e2e8f0;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.list-header {
    padding-bottom: 12px;
    border-bottom: 1px solid #e2e8f0;
    margin-bottom: 12px;
}

.list-title {
    font-size: 14px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
}

.list-items {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.list-item {
    padding: 12px;
    background: #f8fafc;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
    cursor: pointer;
    transition: all 0.2s ease;
}

.list-item:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
}

.item-content {
    font-size: 13px;
    color: #1e293b;
    font-weight: 500;
}

.list-items::-webkit-scrollbar {
    width: 6px;
}

.list-items::-webkit-scrollbar-track {
    background: transparent;
}

.list-items::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
}

.list-items::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
}
</style>
